/* eslint-disable react/prop-types */
import "antd/dist/antd.css";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { authProtectedRoutes, publicRoutes } from "routes";
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import "./assets/scss/theme.scss";
import RootModal from "components/Modal";
import { GlobalStyle } from "components/Common/createGlobalStyle";
import AuthenticatedRoutes from "routes/AuthenticatedRoutes";
import UnauthenticatedRoutes from "routes/UnauthenticatedRoutes";
import httpService from "services/httpService";
import { GET_CURRENT_USER } from "helpers/url_helper";
import { fetchUsers } from "redux-toolkit/slices/Users/userSlice";

export const screens = {
  ["Tài khoản user"]: {
    label: "Tài khoản user",
    path: "/account",
    subPath: "account",
  },
  ["Tài khoản QTV"]: {
    label: "Tài khoản QTV",
    path: "/account-admin",
    subPath: "account-admin",
  },
  ["Lịch sử thi"]: {
    label: "Lịch sử thi",
    path: "/exam-session",
    subPath: "exam-session",
  },
  ["Chủ đề"]: { label: "Chủ đề", path: "/category", subPath: "category" },
  ["Câu hỏi"]: { label: "Câu hỏi", path: "/questions", subPath: "questions" },
  ["Logic trộn đề"]: {
    label: "Logic trộn đề",
    path: "/mixing-rule",
    subPath: "mixing-rule",
  },
  ["Lịch sử đăng nhập"]: {
    label: "Lịch sử đăng nhập",
    path: "/history-login",
    subPath: "history-login",
  },
  ["CT huấn luyện"]: {
    label: "CT huấn luyện",
    path: "/training-template",
    subPath: "training-template",
  },
  ["Sản phẩm công ty"]: {
    label: "Sản phẩm công ty",
    path: "/product",
    subPath: "product",
  },
  ["Chi tiết sản phẩm"]: {
    label: "Chi tiết sản phẩm",
    path: "/product-content",
    subPath: "product-content",
  },
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { screens: [] };
    this.getLayout = this.getLayout.bind(this);
  }

  async componentDidMount() {
    const user = await httpService.get(GET_CURRENT_USER);

    this.setState({
      ...this.state,
      screens: (this.props.userProfile?.screens || user?.screens || []).reduce(
        (newArray, item) => {
          newArray.push(
            {
              path: screens[item]?.path,
            },
            { path: screens[item]?.path + "/:id" }
          );
          return newArray;
        },
        [{ path: "/" }]
      ),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        ...this.state,
        screens: (this.props.userProfile?.screens || []).reduce(
          (newArray, item) => {
            newArray.push(
              {
                path: screens[item]?.path,
              },
              { path: screens[item]?.path + "/:id" }
            );
            return newArray;
          },
          [{ path: "/" }]
        ),
      });
    }
  }

  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const { userProfile } = this.props;

    return (
      <Router>
        <GlobalStyle />
        <Switch>
          {this.state.screens && (
            <Route exact path={this.state.screens.map(route => route.path)}>
              <AuthenticatedRoutes routes={authProtectedRoutes} />
            </Route>
          )}

          <Route exact path={publicRoutes.map(route => route.path)}>
            <UnauthenticatedRoutes routes={publicRoutes} />
          </Route>
        </Switch>
        <RootModal />
      </Router>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.LayoutToolkit,
    userProfile: state.User.userProfile,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUsers: () => dispatch(fetchUsers()),
  };
};

App.propTypes = {
  layout: PropTypes.object,
  fetchUsers: PropTypes.func,
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
